import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";

import type { THotelFormValues } from "@/features/hotels/types/types";

export interface HotelSearchDataContextValue {
  searchData: THotelFormValues | null;
  updateSearchData: Dispatch<SetStateAction<THotelFormValues | null>>;
}

export const HotelSearchDataContext =
  createContext<HotelSearchDataContextValue | null>(null);

export const useHotelSearchDataContext = () => {
  const context = useContext(HotelSearchDataContext);
  if (!context) {
    throw new Error(
      "useHotelSearchDataContext must be used within a HotelSearchDataProvider",
    );
  }
  return context;
};
